export const GET_ALL_MOBILE_RECOMMENDATIONS_REQUEST = "GET_ALL_MOBILE_RECOMMENDATIONS_REQUEST";
export const GET_ALL_MOBILE_RECOMMENDATIONS_SUCCESS = "GET_ALL_MOBILE_RECOMMENDATIONS_SUCCESS";
export const GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE = "GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE";

export const GET_MOBILE_RECOMMENDATION_BY_ID_REQUEST = "GET_MOBILE_RECOMMENDATION_BY_ID_REQUEST";
export const GET_MOBILE_RECOMMENDATION_BY_ID_SUCCESS = "GET_MOBILE_RECOMMENDATION_BY_ID_SUCCESS";
export const GET_MOBILE_RECOMMENDATION_BY_ID_FAILURE = "GET_MOBILE_RECOMMENDATION_BY_ID_FAILURE";

export const GET_RECOMMENDATIONS_VOICE_NOTES_REQUEST = "GET_RECOMMENDATIONS_VOICE_NOTES_REQUEST";
export const GET_RECOMMENDATIONS_VOICE_NOTES_SUCCESS = "GET_RECOMMENDATIONS_VOICE_NOTES_SUCCESS";
export const GET_RECOMMENDATIONS_VOICE_NOTES_FAILURE = "GET_RECOMMENDATIONS_VOICE_NOTES_FAILURE";

export const GET_MOBILE_RECOMMENDATION_TEMPLATE_REQUEST = "GET_MOBILE_RECOMMENDATION_TEMPLATE_REQUEST";
export const GET_MOBILE_RECOMMENDATION_TEMPLATE_SUCCESS = "GET_MOBILE_RECOMMENDATION_TEMPLATE_SUCCESS";
export const GET_MOBILE_RECOMMENDATION_TEMPLATE_FAILURE = "GET_MOBILE_RECOMMENDATION_TEMPLATE_FAILURE";

export const GET_MOBILE_RECOMMENDATION_DROPDOWNS_REQUEST = "GET_MOBILE_RECOMMENDATION_DROPDOWNS_REQUEST";
export const GET_MOBILE_RECOMMENDATION_DROPDOWNS_SUCCESS = "GET_MOBILE_RECOMMENDATION_DROPDOWNS_SUCCESS";
export const GET_MOBILE_RECOMMENDATION_DROPDOWNS_FAILURE = "GET_MOBILE_RECOMMENDATION_DROPDOWNS_FAILURE";

export const UPDATE_MOBILE_RECOMMENDATION_FIELDS_REQUEST = "UPDATE_MOBILE_RECOMMENDATION_FIELDS_REQUEST";
export const UPDATE_MOBILE_RECOMMENDATION_FIELDS_SUCCESS = "UPDATE_MOBILE_RECOMMENDATION_FIELDS_SUCCESS";
export const UPDATE_MOBILE_RECOMMENDATION_FIELDS_FAILURE = "UPDATE_MOBILE_RECOMMENDATION_FIELDS_FAILURE";

export const GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_REQUEST = "GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_REQUEST";
export const GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_SUCCESS = "GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_SUCCESS";
export const GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE = "GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE";

export const UPDATE_MULTI_MOBILE_RECOMMENDATION_REQUEST = "UPDATE_MULTI_MOBILE_RECOMMENDATION_REQUEST";
export const UPDATE_MULTI_MOBILE_RECOMMENDATION_SUCCESS = "UPDATE_MULTI_MOBILE_RECOMMENDATION_SUCCESS";
export const UPDATE_MULTI_MOBILE_RECOMMENDATION_FAILURE = "UPDATE_MULTI_MOBILE_RECOMMENDATION_FAILURE";

export const GET_ALL_MOBILE_RECOMMENDATION_IDS_REQUEST = "GET_ALL_MOBILE_RECOMMENDATION_IDS_REQUEST";
export const GET_ALL_MOBILE_RECOMMENDATION_IDS_SUCCESS = "GET_ALL_MOBILE_RECOMMENDATION_IDS_SUCCESS";
export const GET_ALL_MOBILE_RECOMMENDATION_IDS_FAILURE = "GET_ALL_MOBILE_RECOMMENDATION_IDS_FAILURE";

export const GET_MOBILE_RECOMMENDATION_FILTER_REQUEST = "GET_MOBILE_RECOMMENDATION_FILTER_REQUEST";
export const GET_MOBILE_RECOMMENDATION_FILTER_SUCCESS = "GET_MOBILE_RECOMMENDATION_FILTER_SUCCESS";
export const GET_MOBILE_RECOMMENDATION_FILTER_FAILURE = "GET_MOBILE_RECOMMENDATION_FILTER_FAILURE";
export const SET_MOBILE_RECOMMENDATION_APPLIED_FILTER_NAMES = "SET_MOBILE_RECOMMENDATION_APPLIED_FILTER_NAMES";

export const GET_MOBILE_RECOMMENDATIONS_EXPORT_REQUEST = "GET_MOBILE_RECOMMENDATIONS_EXPORT_REQUEST";
export const GET_MOBILE_RECOMMENDATIONS_EXPORT_SUCCESS = "GET_MOBILE_RECOMMENDATIONS_EXPORT_SUCCESS";
export const GET_MOBILE_RECOMMENDATIONS_EXPORT_FAILURE = "GET_MOBILE_RECOMMENDATIONS_EXPORT_FAILURE";

export const GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_REQUEST = "GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_REQUEST";
export const GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_SUCCESS = "GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_SUCCESS";
export const GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_FAILURE = "GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_FAILURE";

export const UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_SUCCESS = "UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_FAILURE = "UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_FAILURE";

export const RESET_MULTI_MR_COMMON_DATA_SUCCESS = "RESET_MULTI_MR_COMMON_DATA_SUCCESS";
export const RESET_MULTI_MR_COMMON_DATA_FAILURE = "RESET_MULTI_MR_COMMON_DATA_FAILURE";

export const CLEAR_ENTITY_PARAMS = "CLEAR_ENTITY_PARAMS";

export const RESET_REDUCER_SUCCESS = "RESET_REDUCER_SUCCESS";
export const RESET_REDUCER_FAILURE = "RESET_REDUCER_FAILURE";

export const RESET_FORM = "RESET_FORM";

export const GET_TABLE_SUMMARY_DATA_REQUEST = "GET_TABLE_SUMMARY_DATA_REQUEST";
export const GET_TABLE_SUMMARY_DATA_SUCCESS = "GET_TABLE_SUMMARY_DATA_SUCCESS";
export const GET_TABLE_SUMMARY_DATA_FAILURE = "GET_TABLE_SUMMARY_DATA_FAILURE";

export const GET_GROUP_EDIT_PROGRESS_REQUEST = "GET_GROUP_EDIT_PROGRESS_REQUEST";
export const GET_GROUP_EDIT_PROGRESS_SUCCESS = "GET_GROUP_EDIT_PROGRESS_SUCCESS";
export const GET_GROUP_EDIT_PROGRESS_FAILURE = "GET_GROUP_EDIT_PROGRESS_FAILURE";

export const RESET_GROUP_EDIT_PROGRESS_REDUCER_SUCCESS = "RESET_GROUP_EDIT_PROGRESS_REDUCER_SUCCESS";
export const RESET_GROUP_EDIT_PROGRESS_REDUCER_FAILURE = "RESET_GROUP_EDIT_PROGRESS_REDUCER_FAILURE";

export const REVERT_MOBILE_RECOM_REQUEST = "REVERT_MOBILE_RECOM_REQUEST";
export const REVERT_MOBILE_RECOM_SUCCESS = "REVERT_MOBILE_RECOM_SUCCESS";
export const REVERT_MOBILE_RECOM_FAILURE = "REVERT_MOBILE_RECOM_FAILURE";

export const REVERT_MOBILE_RECOM_BY_ID_REQUEST = "REVERT_MOBILE_RECOM_BY_ID_REQUEST";
export const REVERT_MOBILE_RECOM_BY_ID_SUCCESS = "REVERT_MOBILE_RECOM_BY_ID_SUCCESS";
export const REVERT_MOBILE_RECOM_BY_ID_FAILURE = "REVERT_MOBILE_RECOM_BY_ID_FAILURE";

export const SEARCH_AND_REPLACE_MOBILE_RECOM_REQUEST = "SEARCH_AND_REPLACE_MOBILE_RECOM_REQUEST";
export const SEARCH_AND_REPLACE_MOBILE_RECOM_SUCCESS = "SEARCH_AND_REPLACE_MOBILE_RECOM_SUCCESS";
export const SEARCH_AND_REPLACE_MOBILE_RECOM_FAILURE = "SEARCH_AND_REPLACE_MOBILE_RECOM_FAILURE";

export const FIND_MOBILE_RECOM_BEFORE_REPLACE_REQUEST = "FIND_MOBILE_RECOM_BEFORE_REPLACE_REQUEST";
export const FIND_MOBILE_RECOM_BEFORE_REPLACE_SUCCESS = "FIND_MOBILE_RECOM_BEFORE_REPLACE_SUCCESS";
export const FIND_MOBILE_RECOM_BEFORE_REPLACE_FAILURE = "FIND_MOBILE_RECOM_BEFORE_REPLACE_FAILURE";

export const formFields = {
    region_id: {
        fieldName: "region",
        objectKey: "name"
    },
    site_id: { fieldName: "site", objectKey: "name" },
    building_id: { fieldName: "building", objectKey: "name" },
    addition_id: { fieldName: "addition", objectKey: "name" },
    floor: { fieldName: "floor", objectKey: "name" },
    funding_source_id: { fieldName: "funding_source", objectKey: "name" },
    responsibility_id: { fieldName: "responsibility", objectKey: "name" },
    criticality_id: { fieldName: "criticality", objectKey: "name" },
    category_id: { fieldName: "category", objectKey: "name" },
    initiative_id: { fieldName: "initiative", objectKey: "name" },
    department_id: { fieldName: "department", objectKey: "name" },
    main_building_type_id: { fieldName: "building", objectKey: "building_type" },
    trade_id: { fieldName: "trade", objectKey: "name" },
    system_id: { fieldName: "system", objectKey: "name" },
    sub_system_id: { fieldName: "sub_system", objectKey: "name" },
    installed_year: { fieldName: "installed_year" },
    current_age: { fieldName: "current_age" },
    usefull_life_remaining: { fieldName: "usefull_life_remaining" },
    service_life: { fieldName: "service_life" },
    recommendation_capital_type_id: { fieldName: "capital_type_display_name" },
    crv: { fieldName: "crv" },
    recommendation_type: { fieldName: "recommendation_type" },
    birth_year: { fieldName: "birth_year" },
    description: { fieldName: "description" },
    room: { fieldName: "room" },
    asset_condition_id: { fieldName: "condition", assetFieldName: "client_asset_condition", objectKey: "name" }
};

export const RESTORE_DATA_LOG_REQUEST = "RESTORE_DATA_LOG_REQUEST";
export const RESTORE_DATA_LOG_SUCCESS = "RESTORE_DATA_LOG_SUCCESS";
export const RESTORE_DATA_LOG_FAILURE = "RESTORE_DATA_LOG_FAILURE";

export const GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_REQUEST = "GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_REQUEST";
export const GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_SUCCESS = "GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_SUCCESS";
export const GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_FAILURE = "GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_FAILURE";

export const GET_AI_ANALYSE_KEY_REQUEST = "GET_AI_ANALYSE_KEY_REQUEST";
export const GET_AI_ANALYSE_KEY_SUCCESS = "GET_AI_ANALYSE_KEY_SUCCESS";
export const GET_AI_ANALYSE_KEY_FAILURE = "GET_AI_ANALYSE_KEY_FAILURE";

export const UPDATE_SCROLL_SUCCESS = "UPDATE_SCROLL_SUCCESS";
export const UPDATE_SCROLL_FAILURE = "UPDATE_SCROLL_FAILURE";

export const DEFALUT_BAND_VALUE = {
    "Geo Hierarchy": [
        {
            uuid: "",
            index: 1,
            label: "Region",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: true,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true,
                copy_prev: true
            },
            value: "",
            invalid: false,
            is_display: true,
            tooltip: "Region",
            tooltip_pos: "right",
            field_name: "region_id",
            field_type: "custom_select",
            group_field: "Geo Hierarchy",
            default_value: "",
            field_options: []
        },
        {
            uuid: "",
            index: 2,
            label: "Site",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: true,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true,
                copy_prev: true
            },
            value: "",
            invalid: false,
            is_display: true,
            tooltip: "Site",
            tooltip_pos: "right",
            field_name: "site_id",
            field_type: "custom_select",
            group_field: "Geo Hierarchy",
            default_value: ""
        },
        {
            uuid: "",
            index: 3,
            label: "Building",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true,
                copy_prev: true
            },
            value: "",
            invalid: false,
            is_display: true,
            tooltip: "Building",
            tooltip_pos: "right",
            field_name: "building_id",
            field_type: "custom_select",
            group_field: "Geo Hierarchy",
            default_value: ""
        },
        {
            uuid: "7",
            index: 4,
            label: "Building Type",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true,
                copy_prev: true
            },
            value: "",
            invalid: false,
            is_display: true,
            tooltip: "Building Type",
            tooltip_pos: "right",
            field_name: "main_building_type_id",
            field_type: "custom_select",
            group_field: "Geo Hierarchy",
            default_value: ""
        },
        {
            uuid: "",
            index: 5,
            label: "Addition",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true,
                copy_prev: true
            },
            value: "",
            invalid: false,
            tooltip: "Addition",
            tooltip_pos: "right",
            field_name: "addition_id",
            field_type: "custom_select",
            group_field: "Geo Hierarchy",
            default_value: ""
        },
        {
            uuid: "",
            index: 6,
            label: "Floor",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true,
                copy_prev: true
            },
            value: "",
            invalid: false,
            is_display: true,
            tooltip: "Floor",
            tooltip_pos: "right",
            field_name: "floor",
            field_type: "custom_select",
            group_field: "Geo Hierarchy",
            default_value: ""
        },
        {
            uuid: "",
            index: 7,
            label: "Room",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true,
                copy_prev: true
            },
            value: "",
            invalid: false,
            is_display: true,
            tooltip: "Room Name",
            tooltip_pos: "right",
            field_name: "room",
            field_type: "text",
            group_field: "Geo Hierarchy",
            default_value: ""
        }
    ],
    Recommendations: [
        {
            uuid: "",
            index: 3,
            label: "Trade",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true
            },
            value: "",
            invalid: false,
            tooltip: "Trade",
            tooltip_pos: "right",
            field_name: "trade_id",
            field_type: "custom_select",
            group_field: "Recommendations",
            default_value: ""
        },
        {
            uuid: "",
            index: 4,
            label: "System",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true
            },
            value: "",
            invalid: false,
            tooltip: "System",
            tooltip_pos: "right",
            field_name: "system_id",
            field_type: "custom_select",
            group_field: "Recommendations",
            default_value: ""
        },
        {
            uuid: "",
            index: 5,
            label: "Sub-System",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: false,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true
            },
            value: "",
            invalid: false,
            tooltip: "Sub-System",
            tooltip_pos: "right",
            field_name: "sub_system_id",
            field_type: "custom_select",
            group_field: "Recommendations",
            default_value: ""
        },
        {
            uuid: "",
            index: 6,
            label: "Recommendation",
            rules: {
                regex: "",
                prefix: "",
                suffix: "",
                scanner: false,
                mandatory: true,
                read_only: false,
                decimal_scale: 0,
                is_standalone: false,
                allow_negative: false,
                show_suggestion: false,
                thousand_separator: false,
                table_default_visible: true
            },
            value: "",
            invalid: false,
            is_display: true,
            tooltip: "Recommendation",
            tooltip_pos: "right",
            field_name: "description",
            field_type: "text",
            group_field: "Recommendations",
            default_value: ""
        }
    ]
};
export const SEARCH_AND_REPLACE_REMOVED_FIELDS = [
    "code",
    "budget_priority",
    "building",
    "addition",
    "department",
    "capital_type_display_name",
    "category",
    "trade",
    "system",
    "sub_system",
    "buildingType",
    "recommendation_space_type",
    "recommendation_type",
    "project",
    "region",
    "site",
    "criticality",
    "criticality_type",
    "priority",
    "initiative",
    "client",
    "consultancy",
    "floor",
    "funding_source",
    "responsibility",
    "condition",
    "current_age",
    "end_of_service_life",
    "usefull_life_remaining",
    "manufacturer",
    "essential",
    "inspection_date",
    "source",
    "status",
    "fmp",
    "infrastructure_request",
    "red_line",
    "continuous_fca",
    "years_with_value",
    "created_at",
    "updated_at",
    "project_total",
    "project_costs",
    "crv",
    "surveyor",
    "surveyor_role",
    "client_site_id",
    "birth_year",
    "buildingDescription",
    "hospital_name_recomentation",
    "total_opinions_of_cost",
    "unit",
    "ministry",
    "asset_name",
    "asset_tag",
    "capacity",
    "capacity_unit",
    "end_of_service_life",
    "manufacturer_id",
    "refrigerant",
    "serial_number",
    "installed_year",
    "service_life",
    "model_number",
    "recommendation_source_type",
    "surveyor",
    "survey_type",
    "remote_id",
    "recom_surveyor_comments",
    "latitude",
    "longitude",
    "comments"
];
export const customOrder = [
    "code",
    "status",
    "description",
    "region_id",
    "site_id",
    "building_id",
    "main_building_type_id",
    "floor",
    "room",
    "trade_id",
    "system_id",
    "sub_system_id",
    "category_id",
    "recommendation_capital_type_id",
    "funding_source_id"
];
